// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "label.tooltip[data-v-254b1754]{display:block;position:fixed;padding:1rem;color:#fff;background:rgba(0,0,0,.75);z-index:100;font-size:.8rem;text-align:left;border-radius:5px}label.tooltip h4[data-v-254b1754]{color:#fff}label.tooltip[data-v-254b1754]>*{display:block;margin:0;padding:0}@media(max-width:639px){label.tooltip[data-v-254b1754]{display:none}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
